import { map, Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, signal, Signal } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Channel } from '../../catalog/model/channel.type';
import { UserService } from '../../user/services/user.service';
import { LocalService } from '../../../services/storage/local.service';

@Injectable({
  providedIn: 'root',
})
export class ChannelService {
  public selectedChannel = signal<Channel>(null);
  public selectedLocale = signal<string>(null);
  private readonly selectedChannelTaxonomyDetails = signal<Channel>(this.userService.getUser()?.defaultChannel);

  constructor(
    private readonly http: HttpClient,
    private readonly userService: UserService,
    private readonly localService: LocalService
  ) {}

  getLocales(channel): Observable<any> {
    return this.http.get(environment.api_url + 'locales').pipe(
      map((res: any) => {
        const foundChannel = res.find(
          (locale) => locale.channel === channel.channelCode,
        );

        if (foundChannel) {
          this.setSelectedLocale(foundChannel.default);
          return foundChannel;
        }

        return [];
      }),
    );
  }

  getLocalesForMapping(channel){
    const channels = JSON.parse(this.localService.getItem('channels'));
    if (channel && channels) {
      const channel2 = channels.find((c) => c.channel === channel.channelCode);
      return channel2.locales;
    }
    return null;
  }

  getDefaultLocaleSaved() {
    return localStorage.getItem('selectedLocale');
  }

  getChannels() {
    return this.http.get(environment.api_url + 'locales').pipe(map((res: any) => this.saveChannels(res)));
  }

  getSavedLocales() {
    const channel = this.getSelectedChannel();
    const channels = JSON.parse(this.localService.getItem('channels'));
    if (channel && channels) {
      const channel2 = channels.find((c) => c.channel === channel.channelCode);
      return channel2.locales;
    }
    return null;
  }

  saveChannels(channels) {
    this.localService.setItem('channels', JSON.stringify(channels));
    return channels;
  }

  getSavedChannels() {
    if (this.localService.getItem('channels')) {
      return JSON.parse(this.localService.getItem('channels'));
    }
    return null;
  }

  getDefaultLocal(channel, channels) {
    const channelData = channels?.find((c) => c.channel === channel);
    const defaultLocale = channelData?.default;
    this.localService.setItem('defaultLocale', defaultLocale);
    return defaultLocale;
  }

  getLocalesOfChannel(channel, channels) {
    return channels?.find((c) => c.channel === channel)?.locales;
  }

  setSelectedChannel(channel: Channel) {
    this.selectedChannel.set(channel);
    const channels = this.getSavedChannels();
    const channel2 = channels?.find((c) => c.channel === channel.channelCode);
    const locale = channel2?.default;
    this.localService.setItem('selectedLocale', locale);
    this.localService.setItem('selectedChannel', JSON.stringify(channel));
  }

  setSelectedLocale(locale) {
    this.selectedLocale.set(locale);
    this.localService.setItem('selectedLocale', locale);
  }

  getSelectedLocale() {
    const locale = this.localService.getItem('selectedLocale');
    if (locale && locale != 'undefined') {
      return locale;
    } else {
      const channels = this.getSavedChannels();
      const channel = channels?.find((c) => c.channel === this.getSelectedChannel().channelCode);
      return channel?.default;
    }
  }

  getSelectedChannel() {
    const channel = this.localService.getItem('selectedChannel');
    if (channel && channel != 'undefined') {
      return JSON.parse(channel);
    }
    return this.userService.getUser().defaultChannel;
  }

  setSelectedChannelTaxonomyDetails(channel: Channel) {
    this.selectedChannelTaxonomyDetails.set(channel);
  }

  getSelectedChannelTaxonomyDetails(): Signal<Channel> {
    return this.selectedChannelTaxonomyDetails;
  }
}
